import { render, staticRenderFns } from "./App-Init.vue?vue&type=template&id=076a8b92&scoped=true"
import script from "./App-Init.vue?vue&type=script&lang=js"
export * from "./App-Init.vue?vue&type=script&lang=js"
import style0 from "./App-Init.vue?vue&type=style&index=0&id=076a8b92&prod&lang=scss"
import style1 from "./App-Init.vue?vue&type=style&index=1&id=076a8b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a8b92",
  null
  
)

export default component.exports